import React from 'react';
import cn from 'classnames';

import AddFilesIcon from 'widget/shared/icons/AddFilesIcon';
import { IconColor } from 'widget/shared/icons/BaseIcon';
import { WidgetTexts } from 'widget/consts/texts';

import styles from './AddFilesBtn.module.scss';

export type AddFilesBtnProps = {
  className?: string;
  onFilesSelect?: (files: FileList) => void;
};

const AddFilesBtn: React.FC<AddFilesBtnProps> = ({
  className,
  onFilesSelect
}) => {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const inputId = React.useId();

  const handleClick = React.useCallback(() => {
    inputRef.current?.click();
  }, []);

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const { files } = event.target;

      if (files && files.length > 0) {
        onFilesSelect?.(files);
      }

      if (inputRef.current) {
        inputRef.current.value = '';
      }
    },
    [onFilesSelect]
  );

  return (
    <div
      className={cn(styles['add-files'], className)}
      role="button"
      tabIndex={0}
      onClick={handleClick}
    >
      <label htmlFor={inputId} className={styles['hidden-field']}>
        {WidgetTexts.messageForm.attachments.label}
      </label>
      <input
        ref={inputRef}
        id={inputId}
        type="file"
        multiple
        className={styles['hidden-field']}
        onChange={handleChange}
      />
      <AddFilesIcon className={styles['form__icon']} color={IconColor.Gray} />
    </div>
  );
};

export default React.memo(AddFilesBtn);
